var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.6275 16.9961L12.8902 11.2812C13.7098 10.0938 14.2314 8.68359 14.2314 7.125C14.2314 3.19141 11.0275 0 7.15295 0C3.20392 0 0 3.19141 0 7.125C0 11.0586 3.20392 14.25 7.07844 14.25C8.64314 14.25 10.0588 13.7305 11.1765 12.9141L16.9137 18.6289C17.1373 18.8516 17.4353 19 17.7333 19C18.0314 19 18.3294 18.8516 18.553 18.6289C19.0745 18.1836 19.0745 17.4414 18.6275 16.9961ZM10.9529 9.87109L10.5059 10.5391L9.8353 10.9844C9.01569 11.5781 8.04706 11.875 7.07844 11.875C4.47059 11.875 2.38432 9.72266 2.38432 7.125C2.38432 4.52734 4.5451 2.375 7.15295 2.375C9.76079 2.375 11.9216 4.52734 11.9216 7.125C11.8471 8.08984 11.549 9.05469 10.9529 9.87109Z","fill":"#565656"}));
}

SearchInline.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
